import { useRef, useState } from "react"

import isEqual from "lodash-es/isEqual"

import { useEvent } from "./useEvent"

export function useDebouncedState<T>(
  initialState: T,
  timeout = 400
): [T, (next: T) => void, (next: T, timeout?: number) => void] {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [state, setState] = useState<T>(initialState)
  const nextStateRef = useRef<T>(initialState)

  const setDebounced = useEvent((next: T, customTimeout?: number) => {
    if (!isEqual(next, nextStateRef.current)) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      nextStateRef.current = next
      timeoutRef.current = setTimeout(() => {
        setState(next)
      }, customTimeout || timeout)
    }
  })

  return [state, setState, setDebounced]
}
